// Error boundary: https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/error_boundaries/
import React, { ReactNode, ErrorInfo } from 'react';
import { logger } from '../../utils/logger';
import { ErrorBoundaryPublisher } from '../../utils/metrics';

interface Props {
  name: string;
  mobileView?: boolean;
  children: ReactNode;
}

interface State {
  error: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  public override state: State = {
    error: false,
  };

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const message = `Uncaught error on ${
      this.props.mobileView ? 'mobile' : 'desktop'
    } for component ${this.props.name}:`;
    logger.error(message, error, { errorInfo });

    ErrorBoundaryPublisher.publishCounterMonitor(`${this.props.name}-Error`, 1);
    this.setState({ error: true });
  }

  public override render(): ReactNode {
    if (this.state.error) {
      return null;
    }

    ErrorBoundaryPublisher.publishCounterMonitor(`${this.props.name}-Error`, 0);
    return this.props.children;
  }
}
